<script setup lang="ts">
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    const locales = useAvailableLocales();

    const props = defineProps<FormInputProps>();
    const inputData: FormInputData = useFormInput(props);
</script>

<template>
    <FormElement :input-data="inputData">
        <div class="relative">
            <select
                :id="inputData.inputId.value"
                v-model="inputData.model.value"
                :class="`${inputData.className.value} cursor-pointer`"
                :name="inputData.props.inputName"
                :multiple="multiple"
            >
                <slot>
                    <option
                        v-for="locale in locales"
                        :key="locale"
                        :value="locale"
                    >
                        {{ $t(`locales.${locale}`) }}
                    </option>
                </slot>
            </select>
            <i class="fa-solid fa-chevron-down absolute right-2 md:right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none z-10 text-xs"></i>
        </div>
    </FormElement>
</template>
